module.exports = __webpack_public_path__ + "static/fairchance_card_img2@2x-2bd9f7a8d0f2344ca5b5e70515b5e554.jpg";